export default {
    path: '/appointment/calendar-view',
    name: 'appointment.calendarView',
    meta: {
      layout: 'vertical'
    },
    component: () => import('@/views/pages/appointmentManagement/calendar/Calendar.vue'),
  }